import BaseLayer from "./BaseLayer";
import {plotFftRatioFourDUnit} from "../utils/map_utils";

class FFTRatioFourDH extends BaseLayer {

    id = "fftRatioFourDH";
    label = "FFT Ratio 4D H";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {img_type} = this.props.slide;
        let {normBlurValsFourd, rescanThresh, rescanThresh2} = this.props;
        let margin = 3 / 10;
        let sizeOfMarker = 0.3;
        let countRed = 0;
        let countYellow = 0;
        for (let imageKey in normBlurValsFourd) {
            let xc = parseInt(imageKey.split('y')[0].split('x')[1]);
            let yc = parseInt(imageKey.split('y')[1].split('.' + img_type)[0]);

            let v = {};
            let north_neigh = "x" + xc + "y" + (yc - 1);
            if (normBlurValsFourd[north_neigh] && normBlurValsFourd[north_neigh]["SOUTH"]) {
                let ratios = []
                if (normBlurValsFourd[imageKey]["NORTH"] && normBlurValsFourd[north_neigh]["SOUTH"]) {
                    for (let crop = 0; crop < normBlurValsFourd[imageKey]["NORTH"].length; crop++) {
                        let cur_north_val = normBlurValsFourd[imageKey]["NORTH"][crop];
                        let north_neigh_south_val = normBlurValsFourd[north_neigh]["SOUTH"][crop];
                        let rr = Math.round(1000 * Math.min(cur_north_val,
                            north_neigh_south_val) / Math.max(cur_north_val, north_neigh_south_val));
                        ratios.push(rr);
                        if (rr <= rescanThresh * 1000) {
                            if (cur_north_val < north_neigh_south_val) {
                                v['rescan'] = true
                            } else {
                                v['rescan_north'] = true;
                            }
                        }
                    }
                }
                v['NORTH'] = ratios;
            }

            let west_neigh = "x" + (xc - 1) + "y" + yc;
            if (normBlurValsFourd[west_neigh] && normBlurValsFourd[west_neigh]["EAST"]) {
                let ratios = []
                if (normBlurValsFourd[imageKey]["WEST"] && normBlurValsFourd[west_neigh]["EAST"]) {
                    for (let crop = 0; crop < normBlurValsFourd[imageKey]["WEST"].length; crop++) {
                        let cur_west_val = normBlurValsFourd[imageKey]["WEST"][crop];
                        let west_neigh_east_val = normBlurValsFourd[west_neigh]["EAST"][crop];
                        let rr = Math.round(1000 * Math.min(cur_west_val,
                            west_neigh_east_val) / Math.max(cur_west_val, west_neigh_east_val));
                        ratios.push(rr);
                        if (rr <= rescanThresh * 1000) {
                            if (cur_west_val < west_neigh_east_val) {
                                v['rescan'] = true
                            } else {
                                v['rescan_west'] = true;
                            }
                        }
                    }
                }
                v['WEST'] = ratios;
            }
            this.process(v, xc, yc, margin, sizeOfMarker, countRed, countYellow, this.layer.getSource(), rescanThresh, rescanThresh2);
        }
        resolve();
    });

    process = (v, xc, yc, margin, sizeOfMarker, countRed, countYellow, source, rescanThresh, rescanThresh2) => {
        let type = 'H';
        let {rescanThreshValue1, rescanThreshValue2} = this.props;
        plotFftRatioFourDUnit(v, this.props.slide, xc, yc, margin, sizeOfMarker, this.layer.getSource(),
            rescanThreshValue1, rescanThreshValue2, type);
        if (v["WEST"]) {
            for (let crop = 0; crop < v["WEST"].length; crop++) {
                if (v['WEST'][crop] <= 500 + rescanThresh * 500) {
                    countYellow += 1;
                }
                if (v['WEST'][crop] <= rescanThresh * 1000) {
                    countRed += 1;
                }
            }
        }
    }

}

export default FFTRatioFourDH;
